import { useState, useEffect, useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';

export interface CancelSubscriptionModalProps {
  open: boolean;
  theme?: string;
  onConfirm: (data: { reason: string }) => void;
  onCancel: () => void;
}

export function CancelSubscriptionModal({
  open,
  theme,
  onConfirm,
  onCancel,
}: CancelSubscriptionModalProps) {
  const [reason, setReason] = useState('');

  // Reset form when modal opens
  useEffect(() => {
    if (open) {
      setReason('');
    }
  }, [open]);

  const handleSave = useCallback(() => {
    onConfirm({ reason });
  }, [reason, onConfirm]);

  return (
    <BaseFormModal
      open={open}
      title="Cancel Subscription"
      theme={theme}
      saveText="Cancel Subscription"
      cancelText="Go Back"
      saveButtonClass="kstc-btn--danger"
      onSave={handleSave}
      onCancel={onCancel}
    >
      <div className="kstc-form-group">
        <label className="kstc-label" htmlFor="cancelReason">
          Reason for cancellation (optional)
        </label>
        <textarea
          id="cancelReason"
          className="kst-cancel-reason-textarea"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={5}
          placeholder="Please let us know why you're cancelling..."
        />
      </div>
    </BaseFormModal>
  );
}

(window as any).CancelSubscriptionModalReact = CancelSubscriptionModal;
